const data = {
  id: 0,
  formData: {
    effect: 0,//当前选中的特效
    border: {
      radio_val: 'default',
      default: {
        borderWidth: 2,
        borderColor: "rgba(0, 0, 0, 1)",
      },
      custom: {
        borderWidth: 2,
        borderColor: "rgba(0, 0, 0, 1)",
      }
    },
    background: {
      radio_val: 'default',
      default: {
        color: "rgba(255, 255, 255, 0)",
      },
      custom: {
        color: "rgba(255, 255, 255, 1)",
      }
    },
    direction: 'left'
  },
}
export default data


// WEBPACK FOOTER //
// ./src/base/img_effects.js